// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var TicketCategory$ReactHooksTemplate = require("../tickets/ticketCategory.res.js");
var TicketCategoryForm$ReactHooksTemplate = require("./TicketCategoryForm.res.js");

var initialState_selectedTicketCategory = TicketCategory$ReactHooksTemplate.emptyState();

var initialState = {
  loading: true,
  ticketCategories: /* [] */0,
  formAction: "Create",
  ticketCategoryChangeModalToggle: false,
  selectedTicketCategory: initialState_selectedTicketCategory,
  outsideClick: true
};

function reducer(state, action) {
  if (typeof action !== "object") {
    if (action === "FetchTicketCategoriesInProgress") {
      return {
              loading: true,
              ticketCategories: state.ticketCategories,
              formAction: state.formAction,
              ticketCategoryChangeModalToggle: state.ticketCategoryChangeModalToggle,
              selectedTicketCategory: state.selectedTicketCategory,
              outsideClick: state.outsideClick
            };
    } else {
      return {
              loading: state.loading,
              ticketCategories: state.ticketCategories,
              formAction: state.formAction,
              ticketCategoryChangeModalToggle: !state.ticketCategoryChangeModalToggle,
              selectedTicketCategory: state.selectedTicketCategory,
              outsideClick: state.outsideClick
            };
    }
  }
  switch (action.TAG) {
    case "FetchTicketCategoriesCompleted" :
        return {
                loading: false,
                ticketCategories: action._0,
                formAction: state.formAction,
                ticketCategoryChangeModalToggle: state.ticketCategoryChangeModalToggle,
                selectedTicketCategory: state.selectedTicketCategory,
                outsideClick: state.outsideClick
              };
    case "SetFormAction" :
        return {
                loading: state.loading,
                ticketCategories: state.ticketCategories,
                formAction: action._0,
                ticketCategoryChangeModalToggle: state.ticketCategoryChangeModalToggle,
                selectedTicketCategory: state.selectedTicketCategory,
                outsideClick: state.outsideClick
              };
    case "SetTicketCategory" :
        return {
                loading: state.loading,
                ticketCategories: state.ticketCategories,
                formAction: state.formAction,
                ticketCategoryChangeModalToggle: state.ticketCategoryChangeModalToggle,
                selectedTicketCategory: action._0,
                outsideClick: state.outsideClick
              };
    case "SetOutsideClick" :
        return {
                loading: state.loading,
                ticketCategories: state.ticketCategories,
                formAction: state.formAction,
                ticketCategoryChangeModalToggle: state.ticketCategoryChangeModalToggle,
                selectedTicketCategory: state.selectedTicketCategory,
                outsideClick: action._0
              };
    
  }
}

function TicketCategories(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchTicketCategoriesInProgress");
          Js_promise.then_((function (ticketCategory) {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchTicketCategoriesCompleted",
                                  _0: ticketCategory
                                }));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/ticket_categories", (function (param) {
                      return Json_decode.field("ticket_categories", (function (param) {
                                    return Json_decode.list(TicketCategory$ReactHooksTemplate.fromJson, param);
                                  }), param);
                    })));
        }), []);
  var onFormSubmit = function (ticketCategory) {
    var ticketCategoryId = TicketCategory$ReactHooksTemplate.id(ticketCategory);
    var params = {};
    params["ticket_category"] = TicketCategory$ReactHooksTemplate.encode(ticketCategory);
    var match = state.formAction;
    var formSubmitUrl;
    formSubmitUrl = match === "Create" ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/ticket_categories", params) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/ticket_categories/" + String(Belt_Option.getExn(ticketCategoryId)) + "/update", params);
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failed", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              window.location.reload();
            }
            return Promise.resolve();
          }), formSubmitUrl);
  };
  var tmp;
  if (state.loading) {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                  }),
                              JsxRuntime.jsx("span", {
                                    children: "Loading Ticket Categories...",
                                    className: "text-gray-600"
                                  })
                            ],
                            className: "flex items-center space-x-3"
                          }),
                      className: "flex items-center justify-center py-20"
                    }),
                className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
              }),
          className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
        });
  } else {
    var tmp$1;
    if (state.ticketCategoryChangeModalToggle) {
      var match$1 = state.formAction;
      var tmp$2;
      tmp$2 = match$1 === "Create" ? "Create New Ticket Category" : "Update Ticket Category";
      tmp$1 = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          className: "fixed inset-0 transition-opacity",
                          onClick: (function (param) {
                              Curry._1(dispatch, "ToggleTicketCategoryModal");
                            })
                        }),
                    JsxRuntime.jsx("span", {
                          className: "hidden sm:inline-block sm:align-middle sm:h-screen"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "🎫",
                                                        className: "text-lg"
                                                      }),
                                                  JsxRuntime.jsx("h3", {
                                                        children: tmp$2,
                                                        className: "text-lg font-bold text-gray-900"
                                                      })
                                                ],
                                                className: "flex items-center space-x-2"
                                              }),
                                          JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx("img", {
                                                      className: "h-4 w-4",
                                                      src: Image$ReactHooksTemplate.closeIcon
                                                    }),
                                                className: "text-gray-400 hover:text-gray-600 transition-colors duration-200",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, "ToggleTicketCategoryModal");
                                                  })
                                              })
                                        ],
                                        className: "flex items-center justify-between"
                                      }),
                                  className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-4 border-b border-gray-200"
                                }),
                            JsxRuntime.jsx(TicketCategoryForm$ReactHooksTemplate.make, {
                                  selectedTicketCategory: state.selectedTicketCategory,
                                  onFormSubmit: onFormSubmit,
                                  toggleModal: (function (param) {
                                      Curry._1(dispatch, "ToggleTicketCategoryModal");
                                    })
                                })
                          ],
                          className: "inline-block align-bottom bg-white rounded-2xl shadow-2xl border border-gray-100 transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full overflow-hidden"
                        })
                  ],
                  className: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
                }),
            className: "fixed inset-0 z-50 overflow-y-auto",
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.6)"
            }
          });
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("span", {
                                                  children: "🎫",
                                                  className: "text-xl"
                                                }),
                                            className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h1", {
                                                    children: "Ticket Categories",
                                                    className: "text-2xl font-bold text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Organize and classify your support tickets with custom categories",
                                                    className: "text-sm text-gray-600 mt-1"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-center space-x-3"
                                  }),
                              className: "flex items-center justify-between"
                            }),
                        className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                      }),
                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "📋",
                                                  className: "text-lg"
                                                }),
                                            JsxRuntime.jsx("h2", {
                                                  children: "Category List",
                                                  className: "text-lg font-bold text-gray-900"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: String(List.length(state.ticketCategories)) + " categories",
                                                  className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                })
                                          ],
                                          className: "flex items-center space-x-2"
                                        }),
                                    JsxRuntime.jsxs("button", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "+",
                                                  className: "mr-2"
                                                }),
                                            "Create New Category"
                                          ],
                                          className: "inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-sm font-medium rounded-lg hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                          onClick: (function (param) {
                                              Curry._1(dispatch, {
                                                    TAG: "SetFormAction",
                                                    _0: "Create"
                                                  });
                                              Curry._1(dispatch, "ToggleTicketCategoryModal");
                                            })
                                        })
                                  ],
                                  className: "flex items-center justify-between"
                                }),
                            JsxRuntime.jsx("p", {
                                  children: "Manage ticket categories with priorities and color coding",
                                  className: "text-sm text-gray-600 mt-1"
                                })
                          ],
                          className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                        }),
                    JsxRuntime.jsx("div", {
                          children: List.length(state.ticketCategories) > 0 ? JsxRuntime.jsxs("table", {
                                  children: [
                                    JsxRuntime.jsx("thead", {
                                          children: JsxRuntime.jsxs("tr", {
                                                children: [
                                                  JsxRuntime.jsx("th", {
                                                        children: "Name",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Color",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Description",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Priority",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Actions",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      })
                                                ]
                                              }),
                                          className: "bg-gray-50 border-b border-gray-200"
                                        }),
                                    JsxRuntime.jsx("tbody", {
                                          children: $$Array.of_list(List.map((function (ticketCategory) {
                                                      var description = TicketCategory$ReactHooksTemplate.description(ticketCategory);
                                                      var priority = TicketCategory$ReactHooksTemplate.priority(ticketCategory);
                                                      return JsxRuntime.jsxs("tr", {
                                                                  children: [
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("span", {
                                                                                      children: TicketCategory$ReactHooksTemplate.name(ticketCategory),
                                                                                      className: "text-sm font-medium text-gray-900"
                                                                                    }),
                                                                                className: "flex items-center space-x-2"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  JsxRuntime.jsx("div", {
                                                                                        className: "w-6 h-6 rounded-full border-2 border-gray-200 shadow-sm",
                                                                                        style: {
                                                                                          backgroundColor: TicketCategory$ReactHooksTemplate.colorToString(TicketCategory$ReactHooksTemplate.color(ticketCategory))
                                                                                        }
                                                                                      }),
                                                                                  JsxRuntime.jsx("span", {
                                                                                        children: TicketCategory$ReactHooksTemplate.colorToName(TicketCategory$ReactHooksTemplate.color(ticketCategory)),
                                                                                        className: "text-sm text-gray-700"
                                                                                      })
                                                                                ],
                                                                                className: "flex items-center space-x-2"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("span", {
                                                                                children: description !== undefined ? description : "—",
                                                                                className: "text-sm text-gray-600"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("span", {
                                                                                children: priority !== undefined ? "Priority: " + String(priority) : "Priority: 0",
                                                                                className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-full"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("button", {
                                                                                      children: JsxRuntime.jsx("img", {
                                                                                            className: "h-4 w-4",
                                                                                            src: Image$ReactHooksTemplate.edit
                                                                                          }),
                                                                                      className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200",
                                                                                      title: "Edit category",
                                                                                      onClick: (function (param) {
                                                                                          Curry._1(dispatch, {
                                                                                                TAG: "SetFormAction",
                                                                                                _0: "Update"
                                                                                              });
                                                                                          Curry._1(dispatch, "ToggleTicketCategoryModal");
                                                                                          Curry._1(dispatch, {
                                                                                                TAG: "SetTicketCategory",
                                                                                                _0: ticketCategory
                                                                                              });
                                                                                        })
                                                                                    }),
                                                                                className: "flex items-center space-x-2"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        })
                                                                  ],
                                                                  className: "hover:bg-gray-50 transition-all duration-200 hover:shadow-sm"
                                                                }, String(Belt_Option.getExn(TicketCategory$ReactHooksTemplate.id(ticketCategory))));
                                                    }), state.ticketCategories)),
                                          className: "divide-y divide-gray-100"
                                        })
                                  ],
                                  className: "w-full text-sm"
                                }) : JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("span", {
                                                      children: "🎫",
                                                      className: "text-2xl text-gray-400"
                                                    }),
                                                className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("h3", {
                                                        children: "No ticket categories found",
                                                        className: "text-lg font-medium text-gray-900"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: "Get started by creating your first ticket category",
                                                        className: "text-sm text-gray-500 mt-1"
                                                      })
                                                ]
                                              }),
                                          JsxRuntime.jsxs("button", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "+",
                                                        className: "mr-2"
                                                      }),
                                                  "Add Your First Category"
                                                ],
                                                className: "inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-sm font-medium rounded-lg hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, {
                                                          TAG: "SetFormAction",
                                                          _0: "Create"
                                                        });
                                                    Curry._1(dispatch, "ToggleTicketCategoryModal");
                                                  })
                                              })
                                        ],
                                        className: "flex flex-col items-center space-y-4"
                                      }),
                                  className: "text-center py-12"
                                }),
                          className: "overflow-x-auto"
                        })
                  ],
                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                }),
            tmp$1
          ],
          className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
        });
  }
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: "h-full bg-gray-50"
            });
}

var make = TicketCategories;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* initialState Not a pure module */
